const BASE_URL = 'https://junior-georgetta-hassanyouz-eb3e69f6.koyeb.app/api';
export const ProfilePath = 'https://junior-georgetta-hassanyouz-eb3e69f6.koyeb.app/'
export default BASE_URL;